module.exports = __webpack_public_path__ + "static/media/icapidilite.8e518335.png";